import { Routes } from "@angular/router";
import { supplierAuthGuard } from "./core/auth.guard";
import { LoginPageComponent } from "./pages/login-page.component";
import { DashboardPageComponent } from "./pages/dashboard-page.component";
import { OrdersPageComponent } from "./pages/orders-page.component";
import { DiyOrderDetailComponent } from "./pages/diy-order-detail.component";
import { ChangePasswordPageComponent } from "./pages/change-password-page.component";
import { ProfilePageComponent } from "./pages/profile-page.component";

export const routes: Routes = [
  { path: "login", component: LoginPageComponent },
  { path: "", pathMatch: "full", redirectTo: "dashboard" },
  {
    path: "dashboard",
    component: DashboardPageComponent,
    canActivate: [supplierAuthGuard],
  },
  {
    path: "orders/new",
    component: OrdersPageComponent,
    canActivate: [supplierAuthGuard],
    data: {
      kind: "new",
      title: "New orders",
      emptyMessage: "No new orders right now.",
    },
  },
  {
    path: "orders/in-progress",
    component: OrdersPageComponent,
    canActivate: [supplierAuthGuard],
    data: {
      kind: "in-progress",
      title: "In progress",
      emptyMessage: "No orders in progress.",
    },
  },
  {
    path: "orders/past",
    component: OrdersPageComponent,
    canActivate: [supplierAuthGuard],
    data: {
      kind: "past",
      title: "Past orders",
      emptyMessage: "No past orders yet.",
    },
  },
  {
    path: "profile",
    component: ProfilePageComponent,
    canActivate: [supplierAuthGuard],
  },
  {
    path: "change-password",
    component: ChangePasswordPageComponent,
    canActivate: [supplierAuthGuard],
  },
  {
    path: "estimates/:customerId",
    component: DiyOrderDetailComponent,
    canActivate: [supplierAuthGuard],
    data: { kind: "job" },
  },
  {
    path: "diy-orders/:orderId",
    component: DiyOrderDetailComponent,
    canActivate: [supplierAuthGuard],
    data: { kind: "diy" },
  },
  { path: "**", redirectTo: "dashboard" },
];
